import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

const post = (path, payload = {}, authHeaders = {}) =>
  apiCallPost(path, payload, authHeaders);

export const downloadInvoiceApi = (payload, authHeaders) =>
  post(apiPaths.invoice, {
    operation: "DOWNLOAD_INVOICE",
    payload,
  }, authHeaders);

export const getPastTransactionsApi = (payload, authHeaders) =>
  post(apiPaths.invoice, {
    operation: "GET_PAST_TRANSACTIONS",
    payload,
  }, authHeaders);
